import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { Button } from '@pella/sash-framework';

import AddressValidation from '../../address-validation/v3';

import styles from './index.module.scss';

export default function RTASimpleForm({ className, btnText = 'See Availability', children }) {
	const [userAddress, setUserAddress] = useState({});
	const [userAddressComplete, setUserAddressComplete] = useState(false);
	const [userAddressModified, setUserAddressModified] = useState(false);
	const [forceAddressValidation, setForceAddressValidation] = useState(false);

	function onSubmitClick() {
		setForceAddressValidation(true);
		if (!userAddress.address1 || !userAddress.city || !userAddress.state || !userAddress.postalCode) return false;
		navigate('/where-to-buy/schedule-consultation/', { state: { userAddress: userAddress, referrer: window.location.href } });
	}

	return (
		<div
			id='rtaForm'
			className={`${styles.rtaSimpleForm} bg-white p-4 md:p-6 xl:p-8 ${className || ''}`}
		>
			{children}

			<AddressValidation
				allowInternational
				addressComplete={[userAddressComplete, setUserAddressComplete]}
				addressInputs={{
					line1: {
						label: 'Street Address',
						xs: 12,
					},
					line2: { visible: true, xs: 12 },
					city: { xs: 12, xl: 4 },
					state: { xs: 12, xl: 4 },
					postalCode: { xs: 12, xl: 4 },
				}}
				addressInput={{}}
				addressOutput={[userAddress, setUserAddress]}
				addressModified={[userAddressModified, setUserAddressModified]}
				addressValidate={[forceAddressValidation, setForceAddressValidation]}
				className={styles.rtaSimpleForm_Results}
			/>

			<Button
				color='primary-alt'
				onClick={onSubmitClick}
				wide
			>
				{btnText}
			</Button>
		</div>
	);
}

RTASimpleForm.propTypes = {
	className: PropTypes.string,
	btnText: PropTypes.string,
	children: PropTypes.node,
};
